"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectEdge = exports.detectTrident = exports.detectMSIE = void 0;
var extractIEVersion_1 = __importDefault(require("./utils/extractIEVersion"));
var notIE = { isIE: false, name: '', version: '' };
function detectMSIE(userAgent) {
    var hasMsie = userAgent.includes('MSIE ');
    return hasMsie
        ? { isIE: true, name: 'Internet Explorer', version: extractIEVersion_1.default('10', userAgent) }
        : notIE;
}
exports.detectMSIE = detectMSIE;
function detectTrident(userAgent) {
    var hasTrident = userAgent.includes('Trident/');
    var hasRevision = userAgent.includes('rv:');
    return hasTrident && hasRevision
        ? { isIE: true, name: 'Internet Explorer', version: extractIEVersion_1.default('11', userAgent) }
        : notIE;
}
exports.detectTrident = detectTrident;
function detectEdge(userAgent) {
    var hasEdge = userAgent.includes('Edge');
    return hasEdge
        ? { isIE: true, name: 'Edge', version: extractIEVersion_1.default('edge', userAgent) }
        : notIE;
}
exports.detectEdge = detectEdge;
//# sourceMappingURL=detectors.js.map